import React from "react";
import BreadCrumb from "../../Common/BreadCrumb";

import user from "../../assets/images/user.png";
import img2 from "../../assets/images/images-2.jpg";
import { Link } from "react-router-dom";

const Profile = () => {
  return (
    <React.Fragment>
      <BreadCrumb title="Profile" pageType="Users" />

      <div className="flex flex-col gap-4 min-h-[calc(100vh-212px)]">
        <div className="grid grid-cols-1 gap-4">
          <div className="card">
            <div
              className="bg-cover h-72 rounded-lg bg-center"
              style={{ backgroundImage: `url(${img2})` }}
            ></div>
            <div className="relative px-10 -mt-16">
              <div className="flex items-center justify-between gap-5">
                <div className="relative size-32">
                  <img
                    src={user}
                    className="border-8 rounded-full border-light/50"
                    alt=""
                  />
                  <span className="absolute rounded-full size-5 bg-success bottom-2 ltr:right-4 rtl:left-4"></span>
                </div>
                <div>
                  <Link
                    to="/pages-users-settings"
                    className="btn bg-purple border-purple text-white hover:bg-purple/[0.85] hover:border-purple/[0.85]"
                  >
                    Edit
                  </Link>
                </div>
              </div>
              <div className="flex flex-col items-start justify-between md:flex-row gap-7">
                <div className="mt-4 shrink-0">
                  <div>
                    <h5 className="text-xl font-bold dark:text-white">
                      Stevens Laurie
                    </h5>
                    <p className="text-muted dark:text-darkmuted">
                      Ui/Ux Designer
                    </p>
                  </div>
                  <div className="flex flex-wrap items-start gap-5 mt-7">
                    <div>
                      <p className="text-base font-bold dark:text-white">148</p>
                      <p className="text-muted dark:text-darkmuted">Posts</p>
                    </div>
                    <div>
                      <p className="text-base font-bold dark:text-white">78K</p>
                      <p className="text-muted dark:text-darkmuted">
                        Followers
                      </p>
                    </div>
                    <div>
                      <p className="text-base font-bold dark:text-white">
                        1589
                      </p>
                      <p className="text-muted dark:text-darkmuted">
                        Following
                      </p>
                    </div>
                  </div>
                </div>
                <div className="mt-4">
                  <h3 className="text-xl font-bold dark:text-white">
                    About Me
                  </h3>
                  <p className="max-w-4xl mt-5 text-base text-muted dark:text-darkmuted">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Pellentesque posuere fermentum urna, eu condimentum mauris
                    tempus ut. Donec fermentum blandit aliquet. Etiam dictum
                    dapibus ultricies. Sed vel aliquet libero. Nunc a augue
                    fermentum, pharetra ligula sed, aliquam lacus.
                  </p>
                </div>
              </div>
              <div className="mt-12">
                <h3 className="mb-4 text-xl font-bold dark:text-white">
                  Follow me on
                </h3>
                <ul className="flex flex-wrap items-center gap-5">
                  <li>
                    <Link to="#">
                      <svg
                        width="48"
                        height="48"
                        className="inline-block w-10 h-10 mx-auto"
                        viewBox="0 0 48 48"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="24"
                          cy="24"
                          r="24"
                          fill="url(#paint0_linear_1_18118)"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M30.467 8H17.533C12.2765 8 8 12.2765 8 17.533V30.467C8 35.7235 12.2765 40 17.533 40H30.467C35.7235 40 40 35.7235 40 30.467V17.533C39.9999 12.2765 35.7235 8 30.467 8ZM36.7808 30.467C36.7808 33.954 33.954 36.7808 30.467 36.7808H17.533C14.046 36.7808 11.2192 33.954 11.2192 30.467V17.533C11.2192 14.0459 14.046 11.2192 17.533 11.2192H30.467C33.954 11.2192 36.7808 14.0459 36.7808 17.533V30.467ZM24 15.7236C19.4364 15.7236 15.7236 19.4364 15.7236 23.9999C15.7236 28.5634 19.4364 32.2763 24 32.2763C28.5636 32.2763 32.2763 28.5635 32.2763 23.9999C32.2763 19.4363 28.5636 15.7236 24 15.7236ZM24 29.0571C21.207 29.0571 18.9428 26.793 18.9428 24C18.9428 21.207 21.207 18.9428 24 18.9428C26.793 18.9428 29.0571 21.207 29.0571 24C29.0571 26.7929 26.7929 29.0571 24 29.0571ZM34.2756 15.7858C34.2756 16.8811 33.3877 17.769 32.2924 17.769C31.1971 17.769 30.3092 16.8811 30.3092 15.7858C30.3092 14.6906 31.1971 13.8027 32.2924 13.8027C33.3877 13.8027 34.2756 14.6906 34.2756 15.7858Z"
                          fill="white"
                        />
                        <defs>
                          <linearGradient
                            id="paint0_linear_1_18118"
                            x1="9.75"
                            y1="48"
                            x2="31.5"
                            y2="6.22358e-07"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#FBD06F" />
                            <stop offset="0.3" stopColor="#F16C2E" />
                            <stop offset="0.6" stopColor="#C82E96" />
                            <stop offset="1" stopColor="#4E6AD6" />
                          </linearGradient>
                        </defs>
                      </svg>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <svg
                        width="48"
                        height="48"
                        className="inline-block w-10 h-10 mx-auto"
                        viewBox="0 0 48 48"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z"
                          fill="#F26798"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M36.8 23.9822C36.8 24.8478 36.7118 25.7123 36.5387 26.5549C36.3699 27.3775 36.1199 28.1851 35.7924 28.9572C35.4724 29.7155 35.0755 30.4464 34.6118 31.1279C34.1549 31.8051 33.6286 32.4405 33.0504 33.0196C32.471 33.5963 31.8335 34.1212 31.1566 34.58C30.4728 35.0405 29.7409 35.4369 28.9821 35.7583C28.209 36.0841 27.3995 36.3338 26.5776 36.5023C25.7339 36.6758 24.8663 36.7644 23.9994 36.7644C23.1318 36.7644 22.2643 36.6758 21.4218 36.5023C20.5986 36.3338 19.7892 36.0841 19.0166 35.7583C18.2579 35.4369 17.5253 35.0405 16.8415 34.58C16.1646 34.1212 15.5271 33.5963 14.9489 33.0196C14.3702 32.4405 13.8439 31.8051 13.3863 31.1279C12.9251 30.4464 12.5275 29.7155 12.2063 28.9572C11.8787 28.1851 11.6281 27.3775 11.4587 26.5549C11.2875 25.7123 11.2 24.8478 11.2 23.9822C11.2 23.1159 11.2874 22.2496 11.4588 21.4089C11.6282 20.5862 11.8788 19.7774 12.2063 19.0066C12.5276 18.2477 12.9251 17.5162 13.3864 16.8346C13.8439 16.1568 14.3702 15.5227 14.949 14.9429C15.5271 14.3661 16.1647 13.8425 16.8416 13.3844C17.5253 12.9219 18.2579 12.5256 19.0167 12.2036C19.7892 11.8771 20.5986 11.6268 21.4218 11.4596C22.2643 11.2874 23.1319 11.2 23.9994 11.2C24.8663 11.2 25.7339 11.2874 26.5776 11.4596C27.3995 11.6269 28.209 11.8771 28.9822 12.2036C29.7409 12.5256 30.4729 12.9219 31.1566 13.3844C31.8335 13.8425 32.4711 14.3661 33.0505 14.9429C33.6286 15.5227 34.1549 16.1568 34.6118 16.8346C35.0755 17.5162 35.4724 18.2477 35.7924 19.0066C36.1199 19.7774 36.3699 20.5862 36.5387 21.4089C36.7118 22.2496 36.8 23.1159 36.8 23.9822ZM19.3354 14.109C16.2871 15.5465 14.0119 18.3513 13.3025 21.7316L13.313 21.7317C13.6866 21.7351 18.2011 21.7769 23.3943 20.399C21.5024 17.0424 19.481 14.3032 19.3354 14.109ZM13.0769 23.634C13.2707 23.6414 18.6716 23.7625 24.3 22.0799C24.6131 22.6928 24.9126 23.3144 25.1869 23.9348C25.0432 23.976 24.8981 24.0184 24.7556 24.0659C18.8566 25.9707 15.8652 31.2702 15.8689 31.2758C14.1276 29.3428 13.0681 26.7864 13.0681 23.9822C13.0681 23.9013 13.0708 23.8221 13.0735 23.7423L13.0735 23.7423L13.0735 23.7423L13.0735 23.7422L13.0735 23.7422L13.0735 23.7422C13.0747 23.7063 13.0759 23.6703 13.0769 23.634ZM31.2185 15.7898C29.294 14.0953 26.767 13.0674 23.9994 13.0674C23.1112 13.0674 22.2493 13.1748 21.4236 13.3732L21.4414 13.397L21.4414 13.397L21.4414 13.397L21.4414 13.397C21.7004 13.7434 23.6921 16.4073 25.5101 19.7406C29.6009 18.2091 31.166 15.8684 31.2175 15.7913L31.2185 15.7898ZM25.9054 25.752L25.932 25.7435C27.4701 29.7354 28.1052 33.0783 28.267 34.032C26.9551 34.5892 25.5132 34.897 23.9994 34.897C21.4642 34.897 19.1366 34.0276 17.2809 32.5865C17.3036 32.5371 19.4099 28.0124 25.8595 25.7672C25.8746 25.7617 25.89 25.7568 25.9054 25.752ZM30.1078 33.0346C32.5623 31.3807 34.3055 28.7543 34.7918 25.7122C34.5668 25.6398 31.5085 24.673 27.9802 25.2379C29.414 29.1725 29.9966 32.3768 30.1078 33.0346ZM27.0776 22.9499C26.8508 22.4174 26.6051 21.8876 26.3514 21.3671C30.6395 19.6183 32.3978 17.1098 32.4405 17.049L32.4411 17.0481C33.9749 18.9073 34.9018 21.2822 34.9268 23.8698C34.9238 23.8692 34.9195 23.8683 34.9139 23.8671C34.627 23.8074 30.9972 23.0525 27.3139 23.5153C27.2371 23.3281 27.1583 23.1409 27.0776 22.9499Z"
                          fill="white"
                        />
                      </svg>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <svg
                        width="48"
                        height="48"
                        className="inline-block w-10 h-10 mx-auto"
                        viewBox="0 0 48 48"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M48 24C48 10.7438 37.2562 0 24 0C10.7438 0 0 10.7438 0 24C0 35.9813 8.775 45.9094 20.25 47.7094V30.9375H14.1562V24H20.25V18.7125C20.25 12.6984 23.8313 9.375 29.3156 9.375C31.9406 9.375 34.6875 9.84375 34.6875 9.84375V15.75H31.6594C28.6781 15.75 27.75 17.6016 27.75 19.5V24H34.4062L33.3422 30.9375H27.75V47.7094C39.225 45.9094 48 35.9813 48 24Z"
                          fill="#1877F2"
                        />
                        <path
                          d="M33.3423 30.9375L34.4062 24H27.75V19.5C27.75 17.6016 28.6782 15.75 31.6595 15.75H34.6875V9.84375C34.6875 9.84375 31.9406 9.375 29.3156 9.375C23.8313 9.375 20.2501 12.6984 20.2501 18.7125V24H14.1562V30.9375H20.2501V47.7094C21.4735 47.9016 22.725 48 24 48C25.275 48 26.5266 47.9016 27.75 47.7094V30.9375H33.3423Z"
                          fill="white"
                        />
                      </svg>
                    </Link>
                  </li>
                  <li>
                    <Link to="#">
                      <svg
                        width="48"
                        height="48"
                        className="inline-block w-10 h-10 mx-auto"
                        viewBox="0 0 48 48"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z"
                          fill="#349DF0"
                        />
                        <path
                          d="M24.11 18.8523L24.1686 19.8039L23.1931 19.6874C19.6425 19.2407 16.5406 17.726 13.9068 15.182L12.6192 13.9198L12.2876 14.8519C11.5853 16.9298 12.034 19.1242 13.4972 20.6001C14.2775 21.4157 14.1019 21.5323 12.7558 21.0468C12.2876 20.8914 11.8779 20.7749 11.8389 20.8331C11.7023 20.9691 12.1705 22.7363 12.5412 23.4354C13.0484 24.4064 14.0824 25.3579 15.2139 25.9211L16.1699 26.3677L15.0384 26.3872C13.9459 26.3872 13.9068 26.4066 14.0239 26.8144C14.4141 28.0767 15.9553 29.4166 17.6721 29.9992L18.8816 30.407L17.8281 31.0285C16.2674 31.9218 14.4336 32.4267 12.5997 32.4655C11.7218 32.4849 11 32.5626 11 32.6209C11 32.8151 13.3801 33.9026 14.7652 34.3298C18.9207 35.5921 23.8564 35.0483 27.5631 32.8927C30.1968 31.3586 32.8306 28.3097 34.0596 25.3579C34.7229 23.7849 35.3862 20.9108 35.3862 19.532C35.3862 18.6387 35.4448 18.5222 36.5373 17.4541C37.1811 16.8327 37.7858 16.153 37.9029 15.9588C38.098 15.5898 38.0785 15.5898 37.0835 15.92C35.4253 16.5026 35.1911 16.4249 36.0105 15.551C36.6153 14.9296 37.3371 13.8032 37.3371 13.4731C37.3371 13.4148 37.0445 13.5119 36.7128 13.6867C36.3617 13.8809 35.5813 14.1722 34.9961 14.347L33.9426 14.6771L32.9866 14.0363C32.4599 13.6867 31.7185 13.2983 31.3284 13.1818C30.3334 12.9099 28.8117 12.9488 27.9143 13.2595C25.4757 14.1334 23.9345 16.3861 24.11 18.8523Z"
                          fill="white"
                        />
                      </svg>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Profile;
